import React from "react";
import { Trash, Edit as EditIcon } from "./../../../../assets/images/svg";

const UserRow = ({
  item: user,
  onSetCorporate,
  handlePopup,
  renderMenu,
  activeTabClassName,
  index
}) => {
  const {
    id,
    firstName,
    lastName,
    isCorporate,
    userActions: {
      canDestroy,
      canEditUser,
      canLoginAs,
      canLoginAsText,
      canSetAsCorporate,
      canUpdatePermissions
    }
  } = user;
  user.name = lastName + ", " + firstName;
  return (
    <li color="dark" className="group__item" key={id}>
      <div className="group__el text">
        {lastName}, {firstName}{" "}
        {canLoginAsText && <span className="no-permissions">-{canLoginAsText}</span>}
      </div>

      {canSetAsCorporate && (
        <div className="tabs">
          <div
            className="tabs__list"
            onClick={(e) => onSetCorporate({ e, isCorporate, id, index })}
          >
            <button className={`tabs__tab ${!isCorporate ? activeTabClassName : ""}`}>
              Owner/Staff
            </button>
            <button className={`tabs__tab ${isCorporate ? activeTabClassName : ""}`}>
              Corporate User
            </button>
          </div>
        </div>
      )}

      {canLoginAs && (
        <div className="group__el login-as">
          <button className="button button--secondary" onClick={() => handlePopup(user, "loginAs")}>
            Login As
          </button>
        </div>
      )}

      {/* Menu */}
      <div className="group__el users__menu">{renderMenu(user)}</div>

      {(canEditUser || canUpdatePermissions) && (
        <div className="group__el edit">
          <span className="group__icon" onClick={() => handlePopup(user, "edit")} title="Edit">
            <EditIcon />
          </span>
        </div>
      )}

      {canDestroy && (
        <div className="group__el delete">
          <span className="group__icon" onClick={() => handlePopup(user, "delete")} title="Delete">
            <Trash color="#FF0000" />
          </span>
        </div>
      )}
    </li>
  );
};

export default UserRow;
